import { WegetNavbar } from "./wegets/weget-navbar/weget-navbar";

export function LayoutWithNavigationBar({
    children,
    ...props
}) {
    return (
        <>
            <WegetNavbar />
            {children}
        </>
    );
}